import React, { FC } from 'react'

import { Icons } from '../../Icon/types'

import * as SC from './styled'

export type FormSelectProps = React.InputHTMLAttributes<HTMLSelectElement> & {
  className?: string
  label?: string
  name: string
  value?: string
  uppercaseOptions?: boolean
  options: { label: string; value: string }[]
  help?: string
  error?: string
  showError?: boolean
}

const FormSelect: FC<FormSelectProps> = (props) => {
  const {
    className,
    label,
    placeholder,
    options,
    help,
    error,
    showError,
    uppercaseOptions,
    ...selectProps
  } = props

  return (
    <SC.Container className={className} $isDisabled={selectProps.disabled}>
      {label && (
        <SC.Label required={selectProps.required} error={!!error}>
          {label}
        </SC.Label>
      )}
      <SC.SelectContainer>
        <SC.Select $error={!!error} {...selectProps}>
          {placeholder && (
            <option value="" disabled selected>
              {placeholder}
            </option>
          )}
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {uppercaseOptions ? option.label.toUpperCase() : option.label}
            </option>
          ))}
        </SC.Select>
        <SC.SelectArrow icon={Icons.chevronDown} />
      </SC.SelectContainer>
      {help && <SC.Help>{help}</SC.Help>}
      {error && showError && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormSelect
